module.exports = __webpack_public_path__ + "media/svg/refinery-29-647c2965.svg";